import axios from "axios";
import Cookies from "js-cookie";

// V2
const API = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}`,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor // V2
API.interceptors.request.use(
  config => {
    const token = Cookies.get("token");
    // const userId = localStorage.getItem("D_USER_ID");

    if (token) {
      config.headers['Authorization'] = token;
    }
    // config.headers['Content-Type'] = 'application/json';
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// V2
API.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const { response } = error;

    if (error?.response?.status === 403 || error?.response?.status === 401) {
      const Authorization = Cookies.get('token');
      // toast.error('Login expired, redirecting...');
      if (Authorization) {
        Cookies.remove('token');
      }
      setTimeout(() => {
        window.location.href = URL.login;
      }, 5000);

    }

    if (response?.message === 'Network Error') {
      // toast.error(response?.data?.message);
    }

    const apiResponse = response ? response : Promise.reject(error);

    return apiResponse;
  }
);

// V#
const APIV3 = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL_V3}`,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor // V3
APIV3.interceptors.request.use(
  config => {
    const token = Cookies.get("token");
    // const userId = localStorage.getItem("D_USER_ID");

    if (token) {
      config.headers['Authorization'] = token;
    }
    // config.headers['Content-Type'] = 'application/json';
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// V3
APIV3.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const { response } = error;

    if (error?.response?.status === 403 || error?.response?.status === 401) {
      const Authorization = Cookies.get('token');
      // toast.error('Login expired, redirecting...');
      if (Authorization) {
        Cookies.remove('token');
      }
      setTimeout(() => {
        window.location.href = URL.login;
      }, 5000);

    }

    if (response?.message === 'Network Error') {
      // toast.error(response?.data?.message);
    }

    const apiResponse = response ? response : Promise.reject(error);

    return apiResponse;
  }
);

export default API;
export { APIV3 };